// Auto-generated by tools/avatar/generate-face-svgs.mjs
 
import type { RecordOfEyebrowsComponents } from './types'

import AngrySvg from './angry.svg?raw'
import AngryNaturalSvg from './angry-natural.svg?raw'
import DefaultSvg from './default.svg?raw'
import DefaultNaturalSvg from './default-natural.svg?raw'
import FlatNaturalSvg from './flat-natural.svg?raw'
import RaisedExcitedSvg from './raised-excited.svg?raw'
import RaisedExcitedNaturalSvg from './raised-excited-natural.svg?raw'
import SadConcernedSvg from './sad-concerned.svg?raw'
import SadConcernedNaturalSvg from './sad-concerned-natural.svg?raw'
import UnibrowNaturalSvg from './unibrow-natural.svg?raw'
import UpDownSvg from './up-down.svg?raw'
import UpDownNaturalSvg from './up-down-natural.svg?raw'

export const eyebrowsComponents = {
  Angry: AngrySvg,
  AngryNatural: AngryNaturalSvg,
  Default: DefaultSvg,
  DefaultNatural: DefaultNaturalSvg,
  FlatNatural: FlatNaturalSvg,
  RaisedExcited: RaisedExcitedSvg,
  RaisedExcitedNatural: RaisedExcitedNaturalSvg,
  SadConcerned: SadConcernedSvg,
  SadConcernedNatural: SadConcernedNaturalSvg,
  UnibrowNatural: UnibrowNaturalSvg,
  UpDown: UpDownSvg,
  UpDownNatural: UpDownNaturalSvg,
} satisfies RecordOfEyebrowsComponents

export type EyebrowsComponentName = keyof typeof eyebrowsComponents
